import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    option: "incomplete",
    colors: [],
};

const todoSlice = createSlice({
    name: "todo",
    initialState,
    reducers: {
        addOption: (state, action) => {
            state.option = action.payload;
        },
        addColor: (state, action) => {
            const isExist = state.colors.some(
                (color) => color === action.payload
            );
            if (!isExist) {
                state.colors.push(action.payload);
            } else {
                state.colors = state.colors.filter(
                    (color) => color !== action.payload
                );
            }
        },
    },
});

export const { addOption, addColor } = todoSlice.actions;
export default todoSlice.reducer;
